exports = module.exports = require("../../../../../../css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "@media (min-width: 1024px){.mobile-only{display:none !important}}@media (max-width: 1023px){.desktop-only{display:none !important}}.sf-section{margin:var(--section-margin, calc(var(--spacer-lg) * 2) 0 var(--spacer-lg) 0)}.sf-section__content{margin:var(--section-content-margin, calc(var(--spacer-lg) * 2) 0 0 0)}@media (min-width: 1024px){.sf-section{--section-margin: var(--spacer-3xl) 0;--section-content-margin: var(--spacer-2xl) 0 0 0}}\n", ""]);

// exports
